module.exports = __webpack_public_path__ + "static/mock-video-88ac490f38ac8bc29acc173910398d0c.jpg";